import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

import API from 'my-core/api';
import { onlineCourseBookletRequested } from 'my-core/gtm-events';

import { BOOKLET_BANNER_KEY } from 'my-components/Root/SiteWideBanner';

import { toggleSiteWideBanner } from 'my-actions/AppStateActions';
import { addErrorMessage, addMessage } from 'my-actions/MessageActions';

export default function useOnlineCourseBookletPrint() {
  const dispatch = useDispatch();
  const [fetching, setFetching] = useState(false);
  const autoPrint = useCallback(
    (id, path, printParams) => {
      setFetching(true);
      API.getJSON(`/online-courses/${id}/print_pdf/${path?.replace(/^\/+/, '') || ''}`, printParams)
        .then(resp => {
          onlineCourseBookletRequested(id, path, printParams, !!resp.url);

          if (printParams?.ss_attach) {
            dispatch(
              addMessage(
                'Booklet is being generated. It will automatically be attached to the study session when completed!',
              ),
            );
            return;
          }
          if (resp.url) {
            // Safari prevents window.open from async callbacks, but setTimeout workaround appears to work
            setTimeout(() => {
              const win = window.open(resp.url, '_blank');
              if (!win) {
                dispatch(toggleSiteWideBanner(true, { key: BOOKLET_BANNER_KEY, props: { link: resp.url } }));
              }
            }, 0);
            return;
          }
          dispatch(toggleSiteWideBanner(true, { key: BOOKLET_BANNER_KEY, props: { link: resp.url } }));
        })
        .catch(e => {
          dispatch(addErrorMessage(e));
        })
        .finally(() => setFetching(false));
    },
    [dispatch],
  );

  return [autoPrint, fetching];
}
